module.exports = __webpack_public_path__ + "static/img/banner.8dce2b52.jpg";